import { Colors, Fonts } from "../../config";

const styles = {
    containerStyle: {
        padding: 5
    },
}

export default styles;